import { render, staticRenderFns } from "./CargoEditData.vue?vue&type=template&id=433682a2"
import script from "./CargoEditData.vue?vue&type=script&lang=js"
export * from "./CargoEditData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports